import "orejime/dist/orejime.scss";

var orejimeConfig = {
    privacyPolicy: "{{ path('legal') }}",
    mustConsent: false,
    mustNotice: false,
    lang: "fr",
    translations: {
        fr: {
            poweredBy: !1,
            consentNotice: {
                description: "Ce site utilise des cookies permettant de visualiser des contenus et d'améliorer le fonctionnement grâce aux statistiques de navigation. Si vous cliquez sur « Accepter », la Malle Postale déposera ces cookies sur votre terminal lors de votre navigation. Si vous cliquez sur « Refuser », ces cookies ne seront pas déposés. Votre choix est conservé pendant 6 mois et vous pouvez être informé et modifier vos préférences à tout moment sur la page « Gérer les cookies ».",
                learnMore: "Gérer les cookies"
            },
            consentModal: {
                title: "Gestion des cookies",
                description: "Un cookie est un fichier texte déposé sur votre ordinateur lors de votre visite sur le site. Il permet de conserver vos données de navigation. \nLe site lamallepostale.com utilise des services de mesure d'audience permettant de générer des statistiques anonymes utiles à l'amélioration du site que vous pouvez désactiver à tout moment sur cette page."
            },
            app: {
                optOut: {
                    title: ""
                },
                required: {
                    title: ""
                },
                purposes: "Utilisations",
                purpose: "Utilisation"
            }
        }
    },
    apps: [
        {
            name: "internal-tracker",
            title: "Cookies techniques nécessaires au bon fonctionnement du site",
            description: "Utilisation: Ces cookies permettent au site de fonctionner de manière optimale. Vous pouvez vous y opposer et les supprimer en utilisant les paramètres de votre navigateur, cependant votre expérience utilisateur risque d’être dégradée.",
            required: !0
        },
        {
            name: "google-analytics",
            title: "Google Analytics : mesure d’audience  et d’utilisation du site",
            cookies: ["_ga", "_gat", "_gid"],
            description: 'Utilisation: Ils permettent également d’obtenir des statistiques de fréquentation anonymes du site afin d’optimiser son ergonomie, sa navigation et ses contenus. <a href="https://policies.google.com/privacy" target="_blank" title="politique de confidentialité du cookie Google Analytics - nouvelle fenêtre">"Politique de confidentialité"</a>',
            required: !1,
            optOut: !1,
            default: !1,
            onlyOnce: !1
        },
        {
            name: "facebook",
            title: "Pixel Facebook",
            cookies: ["_fbp"],
            description: 'Utilisation: Le pixel Facebook est un outil d’analyse qui permet de mesurer l’efficacité de publicités en suivant les actions entreprises par les internautes sur un site web."</a>',
            required: !1,
            optOut: !1,
            default: !1,
            onlyOnce: !1
        }
    ]
}

let Orejime = require('orejime');

Orejime.init(orejimeConfig);